/**
 * Mixin to handle A/B testing functionality
 */
export default {
  data() {
    return {
      abTestVersion: null,
    }
  },

  methods: {
    /**
     * Get or set the A/B test version
     * @param {string} testName - Name of the A/B test
     * @param {Array} versions - Array of available versions
     * @returns {string} The selected version
     */
    getABTestVersion(testName, versions = ['A', 'B']) {
      const cookieName = `ab_test_${testName}`

      // Check if a cookie with the version already exists
      let version = this.getCookie(cookieName)

      // If no cookie exists, select a random version
      if (!version || !versions.includes(version)) {
        version = this.selectRandomVersion(versions)
        this.setCookie(cookieName, version, 365)
      }

      return version
    },

    /**
     * Select a random version
     * @param {Array} versions - Array of available versions
     * @returns {string} Randomly selected version
     */
    selectRandomVersion(versions) {
      const randomIndex = Math.floor(Math.random() * versions.length)
      return versions[randomIndex]
    },

    /**
     * Sets a cookie
     * @param {string} name - Name of the cookie
     * @param {string} value - Value of the cookie
     * @param {number} days - Days until expiration
     */
    setCookie(name, value, days) {
      if (process.client) {
        const expires = new Date()
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`
      }
    },

    /**
     * Get a cookie value by name
     * @param {string} name - Name of the cookie
     * @returns {string|null} Cookie value or null if it doesn't exist
     */
    getCookie(name) {
      if (process.client) {
        const nameEQ = name + '='
        const ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i]
          while (c.charAt(0) === ' ') c = c.substring(1, c.length)
          if (c.indexOf(nameEQ) === 0)
            return c.substring(nameEQ.length, c.length)
        }
      }
      return null
    },

    /**
     * Remove a cookie by name
     * @param {string} name - Name of the cookie
     */
    removeCookie(name) {
      if (process.client) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`
      }
    },
  },
}
